/**
 * @generated SignedSource<<e3f1213db8ed623bf2995efbd8cd8715>>
 * @relayHash f4b977b35e60ab460b766c3ccc660a1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 921a4b78b5036923abf4eebe4e2b187cd17372e49c01fe8ec6d70afc7bbad71b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmProjectMenuContent_SidebarQuery$variables = {
  cloudId: string;
  projectId: string;
};
export type JsmProjectMenuContent_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  };
};
export type JsmProjectMenuContent_SidebarQuery = {
  response: JsmProjectMenuContent_SidebarQuery$data;
  variables: JsmProjectMenuContent_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "projectId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "JiraProjectLevelSidebarMenuCustomization",
  "kind": "LinkedField",
  "name": "jira_projectLevelSidebarMenuCustomization",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
      "kind": "LinkedField",
      "name": "hiddenMenuItems",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraProjectLevelSidebarMenuItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "itemId"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v2/*: any*/),
        "action": "THROW",
        "path": "jira_projectLevelSidebarMenuCustomization"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": [
      (v2/*: any*/)
    ]
  },
  "params": {
    "id": "921a4b78b5036923abf4eebe4e2b187cd17372e49c01fe8ec6d70afc7bbad71b",
    "metadata": {},
    "name": "JsmProjectMenuContent_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "723046fdf351decec56fe3e986b67724";

export default node;
